import AdminPublicEnv from 'src/utils/admin-public-env';

export function getAdminAssetUrl(path: string): string {
  if (!AdminPublicEnv.isBackofficeHosted) {
    return path;
  }

  try {
    if (!AdminPublicEnv.adminUrl) {
      throw new Error('missing Admin URL');
    }
    const adminUrl = new URL(AdminPublicEnv.adminUrl);
    if (!['http:', 'https:'].includes(adminUrl.protocol)) {
      throw new Error('unsupported protocol');
    }
    return new URL(path, adminUrl).toString();
  } catch {
    throw new Error('Back Office-hosted assets require a valid Admin URL');
  }
}
